/**
 * card.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Card as MuiCard,
  CardHeader,
} from '@mui/material';
import { Types } from 'utils/constants';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  headerRoot: {
    height: theme.spacing(7),
    backgroundColor: props => {
      if (props.titleStyle === 'med') {
        return theme.palette.grey.colors[7];
      } else if (props.titleStyle === 'dark') {
        if (props.recordGroupType === Types.RecordGroup.TRAINING) {
          return theme.palette.comp.recordRow.event.background;
        } else if (props.recordGroupType === Types.RecordGroup.DEPLOYMENT) {
          return theme.palette.comp.recordRow.deployment.background;
        } else if (props.recordGroupType === Types.RecordGroup.CLASS) {
          return theme.palette.comp.recordRow.class.background;
        } else if (props.recordGroupType === Types.RecordGroup.VET_VISIT) {
          return theme.palette.comp.recordRow.vet.background;
        }
        return theme.palette.comp.appBar.background;
      } else if (props.titleStyle === 'warning') {
        return theme.palette.warning.main;
      } else if (props.titleStyle === 'error') {
        return theme.palette.error.main;
      }
    }
  },
  headerTitle: {
    fontSize: theme.typography.sizes[5],
    color: props => {
      if (props.titleStyle === 'dark') {
        return theme.palette.sys.onPrimary;
      } else if (props.titleStyle === 'warning') {
        return theme.palette.sys.onPrimary;
      } else if (props.titleStyle === 'error') {
        return theme.palette.sys.onPrimary;
      }
    },
  },
  leftHeaderActions: {
    display: 'flex',
    color: props => {
      if (props.titleStyle === 'dark') {
        return theme.palette.sys.onPrimary;
      }
    },
    '&> *' : {
      marginRight: theme.spacing(2),
    },
  },
  rightHeaderActions: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    color: props => {
      if (props.titleStyle === 'dark') {
        return theme.palette.sys.onPrimary;
      }
    },
    '&> *' : {
      marginLeft: theme.spacing(2),
    },
  }
}));

export default function Card(props) {
  const {
    className,
    style,
    title,
    leftHeaderActions,
    rightHeaderActions,
    'data-testid': dataTestid,
    titleStyle,
    children,
    recordGroupType,
    ...rest
  } = props;
  const classes = useStyles(props);

  return (
    <MuiCard
      className={`${classes.root} ${className} element-default-box-shadow`}
      style={style}
      data-testid={dataTestid}
      {...rest}
    >
      {title &&
      <CardHeader
        classes={{
          root: classes.headerRoot,
        }}
        title={
          <div className='flex-hc'>
            {leftHeaderActions &&
            <div className={classes.leftHeaderActions}>
              {leftHeaderActions}
            </div>}
            <div className={`flex-hc ${classes.headerTitle}`}>
              {title}
            </div>
            {rightHeaderActions &&
            <div className={classes.rightHeaderActions}>
              {rightHeaderActions}
            </div>}
          </div>
        }
      />}
      {children}
    </MuiCard>
  );
}